<template>
  <nav style="z-index: 3">
    <v-toolbar
      height="60"
      style="background: linear-gradient(90deg, #6a92c4, #4a6fa5)"
      dense
      flat
    >
      <v-img
        alt="Logo"
        class="shrink app"
        contain
        @click="NavigateToMain()"
        src="@/assets/Sundae_Logo.png"
        transition="scale-transition"
        width="100"
        :height="$vuetify.breakpoint.smAndDown ? 40 : 60"
      />
      <p
        v-show="!$vuetify.breakpoint.smAndDown"
        style="
          color: #fff;
          margin-left: 1rem;
          font-size: 18px;
          margin-top: 14px;
          cursor: default;
          font-weight: 500;
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        "
      >
        Sundae Application
      </p>
      <v-spacer></v-spacer>
      <v-btn
        small
        outlined
        color="white"
        class="mr-4"
        @click="toggleLanguage()"
      >
        {{ $i18n.locale.toUpperCase() }}
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on: menu }">
          <v-btn icon v-on="{ ...menu }">
            <v-icon style="color: #ffd54f">mdi-menu-down</v-icon>
          </v-btn>
          <div style="display: flex; align-items: center">
            <v-icon class="mr-2" size="25" color="white">
              mdi-account-circle
            </v-icon>
            <span style="font-size: 18px; color: #fff; font-weight: 500">
              {{ Username }}
            </span>
          </div>
        </template>
        <v-list style="background: linear-gradient(180deg, #ffffff, #e3f2fd)">
          <v-list-item
            v-for="(item, index) in ListItemMenu"
            :key="index"
            class="d-flex flex-wrap"
          >
            <v-list-item-title
              style="cursor: pointer; color: #1e88e5"
              @click="ActionMenu(item)"
            >
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-dialog v-model="EditUserDialog" persistent max-width="700px">
      <v-card class="rounded-xl elevation-4">
        <v-card-title class="d-flex align-center justify-space-between">
          <span class="text-h6 font-weight-bold text-primary">{{
            $t("message.ChangePassword")
          }}</span>
          <v-btn icon @click="CloseEditUserDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  :label="$t('message.Username')"
                  disabled
                  outlined
                  dense
                  prepend-inner-icon="mdi-account"
                  v-model="Username"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="EditOldPassword"
                  :label="$t('message.OldPassword')"
                  id="oldpassword"
                  outlined
                  dense
                  type="password"
                  prepend-inner-icon="mdi-lock"
                  :append-icon="flagOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="TogglePassword"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="EditPassword"
                  :label="$t('message.NewPassword')"
                  outlined
                  id="newpassword"
                  dense
                  type="password"
                  prepend-inner-icon="mdi-lock-plus"
                  :append-icon="flagPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="ToggleNewPassword"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="EditConfirmPassword"
                  :label="$t('message.ConfirmNewPassword')"
                  id="confirmpassword"
                  outlined
                  dense
                  type="password"
                  prepend-inner-icon="mdi-lock-check"
                  :append-icon="flagConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="ToggleConfirmPassword"
                />
              </v-col>
            </v-row>
            <v-row justify="center" class="mt-4">
              <v-btn
                large
                color="success"
                class="white--text rounded-lg px-8"
                elevation="2"
                @click="ChangePassword()"
                >{{ $t("message.Update") }}</v-btn
              >
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
export default {
  data() {
    return {
      url: enurl.apiUrl,
      Username: this.$cookies.get("Username"),
      ManageRole: false,
      ManageUser: false,

      EditUserDialog: false,
      flagOldPassword: false,
      flagPassword: false,
      flagConfirmPassword: false,
      ListItemMenu: [],

      itemsMenuAdmin: [
        { title: "Manage Users" },
        { title: "Manage Role" },
        { title: "Change Password" },
        { title: "Logout" },
      ],
      itemsMenu: [{ title: "Change Password" }, { title: "Logout" }],

      EditUsername: "",
      EditOldPassword: "",
      EditPassword: "",
      EditConfirmPassword: "",
    };
  },

  mounted() {
    let self = this;
    self.GetDataPermission();
  },

  methods: {
    NavigateToMain() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    ActionMenu(data) {
      let self = this;
      switch (data.id) {
        case 1:
          self.$router.push("/ManageUser");
          break;
        case 2:
          self.ManageDataRole();
          break;
        case 3:
          self.$router.push("/ManageSection");
          break;
        case 4:
          self.$router.push("/BlacklistVisitor");
          break;
        case 5:
          self.EditUser();
          break;
        case 6:
          self.Logout();
          break;
      }
    },

    EditUser() {
      let self = this;
      let token = this.$cookies.get("Token");
      self.GetDataUserByToken(token);
    },

    ManageDataRole() {
      let self = this;
      self.$router.push("/ManageRole");
    },

    GetDataPermission() {
      let self = this;
      axios
        .get(`${self.url}Permission/getDataMenuPermission`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListItemMenu = [];
            if (response.data.data.manageUser == true) {
              self.ListItemMenu.push({
                title: self.$t("message.ManageUser"),
                id: 1,
              });
            }
            if (response.data.data.manageRole == true) {
              self.ListItemMenu.push({
                title: self.$t("message.ManageRole"),
                id: 2,
              });
            }
            if (response.data.data.approver == true) {
              self.ListItemMenu.push({
                title: self.$t("message.ManageSection"),
                id: 3,
              });
            }
            if (response.data.data.blackListVisitor == true) {
              self.ListItemMenu.push({
                title: self.$t("message.BlackList"),
                id: 4,
              });
            }
            self.ListItemMenu.push({
              title: self.$t("message.ChangePassword"),
              id: 5,
            });
            self.ListItemMenu.push({ title: self.$t("message.Logout"), id: 6 });
          }
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    GetDataUserByToken(token) {
      let self = this;
      let temp = {
        token: token,
      };
      axios
        .post(`${self.url}Login/GetDataUserByToken`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.MappingEditUser(response.data.data);
          }
        })
        .catch(function (error) {
          console.log(error);
          // alert(error);
        });
    },

    ChangePassword() {
      let self = this;
      if (self.EditPassword != self.EditConfirmPassword) {
        Swal.fire({
          icon: "error",
          title: "Error...",
          width: 900,
          text: "กรุณากรอก Password ให้ถูกต้องและตรงกัน",
        });
      }
      self.LoadingDialog = true;
      let temp = {
        oldPassword: self.EditOldPassword,
        newPassword: self.EditPassword,
      };
      axios
        .post(`${self.url}Login/ChangePassword`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.Logout();
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    MappingEditUser(data) {
      let self = this;
      self.EditUsername = data.username;
      self.EditUserDialog = true;
    },

    CloseEditUserDialog() {
      let self = this;
      self.EditOldPassword = "";
      self.EditPassword = "";
      self.EditConfirmPassword = "";
      self.EditUserDialog = false;
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("oldpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagOldPassword = false;
      } else {
        x.type = "password";
        self.flagOldPassword = true;
      }
    },

    ToggleNewPassword() {
      let self = this;
      var x = document.getElementById("newpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagPassword = false;
      } else {
        x.type = "password";
        self.flagPassword = true;
      }
    },

    ToggleConfirmPassword() {
      let self = this;
      var x = document.getElementById("confirmpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagConfirmPassword = false;
      } else {
        x.type = "password";
        self.flagConfirmPassword = true;
      }
    },

    Logout() {
      let self = this;
      self.$store
        .dispatch("Logout")
        .then(function () {
          self.$router.push("/Login");
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    toggleLanguage() {
      this.GetDataPermission();
      this.$i18n.locale = this.$i18n.locale === "en" ? "th" : "en";
    },
  },
};
</script>
<style>
.app {
  margin-left: 1rem;
  cursor: pointer;
}
.list {
  cursor: pointer;
}
.apptitle {
  font-family: "Roboto", sans-serif;
  font-size: 20px !important;
}
.v-list-item__content {
  font-family: "Roboto", sans-serif;
  font-size: 20px !important;
}
.mdi-menu-down::before {
  color: black;
}
.white-color {
  background-color: red;
  color: red;
}
.item-title {
  font-size: 16px;
  font-weight: 500;
}
.v-application--is-ltr
  .v-list-group--no-action.v-list-group--sub-group
  .v-list-group__items
  .v-list-item {
  padding-left: 20px !important;
}
</style>
